import angular from 'angular'
import dataCollection from './dataCollection'

export default angular
  .module('app.dataCollection', [])
  .directive('deductionChecks', dataCollection).name



// WEBPACK FOOTER //
// ./src/components/dataCollection/index.js